import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

createApp(App).use(store).use(router).mount('#app')

let prevScrollPos = window.pageYOffset;

window.onscroll = function() {
    const currentScrollPos = window.pageYOffset;

    const navbar = document.querySelector('.navbar');

    if(navbar == null){
        return;
    }
    const navbarHeight = 0 - navbar.offsetHeight;

    if(document.body.classList.contains("scroll")) {

        if ( (prevScrollPos - currentScrollPos) >= 1 || prevScrollPos === 0 ) {
            document.getElementById("navbar").style.top = "0";
        } else {
            document.getElementById("navbar").style.top = `${navbarHeight}px`;
        }
        prevScrollPos = currentScrollPos;
    }
};

